export const termOfUseData = {
  lastUpdated: "30 Jan 2025",
  useDate: true,
  terms: [
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-light-title",
          text: "PLEASE READ THIS DOCUMENT CAREFULLY BEFORE ACCESSING OR USING ANY PART OF THE SITE."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "p",
          class: "terms-description",
          text: "This website (the “Site”) Pastime LIVE, INC. d/b/a Finance Razor (\"Pastime LIVE”, “the Company”, \"we\", \"our\" or \"us\"). By accessing or using the Site or using our services, you expressly acknowledge and agree that your use of the Site is subject to these Terms of Use (together with the Privacy Policy, the \"Terms\"). If you do not agree to be bound by these Terms please do not access or use the Site."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "No information on the Site is to be construed as financial product advice or a recommendation, to buy or sell any financial product. The Services provided by do not constitute an offer, invitation, solicitation or recommendation in relation to the subscription, purchase or sale of financial products."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Please note that generally you, either on your own or through an independent third party, as required by applicable law, can apply for a personal loan without the use of the Services directly with a personal loan provider."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "1. Changes to the Terms."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We reserve the right, at our discretion, to change these Terms at any time. The most recent date of changes will be as reflected in the \"Last updated\" date above, and your continued use of the Site thereafter means that you accept those changes."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "2. Site Access and Use of the Service."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "This Site is only intended for individuals aged eighteen (18) years or older, residing in applicable territories, as specified in Annex I below. If you are under 18 years, please do not visit or use the Site. This Site and its services are for personal use only."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "3. The Integrity of Your Information."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Some of the services on the Site require you to provide us information about you, some of which may be of personal nature and may also include information about personal finances. Should you provide such information to us, you undertake to only provide information that is accurate, true, complete and current, and to truthfully represent your identity. We are not responsible for any Service-related issues arising from your failure to provide true, accurate, current and complete Application Information. If we determine, in our sole discretion, that you have failed to do so, we may suspend or terminate your access to the Site and Service. Our collection, use and disclosure of your personal information is subject to these Terms and our Privacy Policy."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "4. The Service."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "The Site, through some of its features, allows you to submit an online request (\"Match Request\") to be matched with one or more of our third-party Car insurance  partners and/or other third parties who offer their products and/or services, platforms and service providers, who may in turn contact you with offers for insurance  products (“Partners”). By filling in and submitting the Match Request you specifically authorize us to share the Match Request and its information with the Partners. If you decide to engage with one (or more) of our Partners you will need to enter into a separate, independent agreement with each applicable Partner. You acknowledge and agree that we share the Match Request with Partners on your behalf."
        },
        {
          tagType: "p",
          class: "terms-bold-description",
          text: "IF YOU SUBMIT A MATCH REQUEST, PARTNERS MAY CONTACT YOU DIRECTLY WITH QUOTES OR OFFERS VIA ALL MEANS OF COMMUNICATION PROVIDED BY YOU. THESE COMMUNICATIONS ARE SUBJECT TO THE PARTNERS’ RESPECTIVE TERMS AND ANY RIGHT YOU MAY WISH TO EXERCISE SHOULD BE ADDRESSED TO THE PARTNERS, INCLUDING WITHOUT LIMITATION, REQUESTS TO OPT OUT OF MARKETING COMMUNICATIONS."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Please note that Partners receiving a Match Request may conduct additional research necessary to process your request. Such research may include, among other things, inquiries regarding your credit status. However, such research will not affect your credit score."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "5. Third-Party Sources and Content."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Portions of the Site involve linking to web sites belonging to third parties. We have no control over third-party sites, and all use of third-party sites is at your own risk. Additionally, We cannot accept responsibility for any payments processed or submitted through such third party sites, or for the privacy policies of any such sites. We are not responsible for content available by means of such sites. We do not endorse any products offered by third parties and we urge our users to exercise caution in using third-party sites."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "6. Intellectual Property Rights and Restrictions."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Without derogating from the generality of the above, We own (or have valid authorizations or licenses required for) the Site, as well as the materials provided on this Site (including without limitation, the Services), including all worldwide intellectual property rights in the Site and the Services, and the trademarks, service marks, and logos contained therein. Except as expressly permitted herein, you may not copy, further modify, duplicate, distribute, display, perform, sublicense, republish, retransmit, reproduce, create derivative works of, transfer, sell or otherwise use the Site or any content appearing on the Site, including without limitation, the Services. You will not remove, alter or conceal any copyright, trademark, service mark or other proprietary rights notices incorporated in the Site or the Services. All trademarks are trademarks or registered trademarks of their respective owners. Nothing in these Terms grants you any right to use any trademark, service mark, logo, or trade name of the Company or any third party."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "You may not or attempt to (a) decipher, decompile, disassemble, or reverse-engineer any of the software used to provide the Site or the Services; (b) circumvent, disable, or otherwise interfere with security-related features of the Site or Services or features that prevent or restrict use or copying of any content; (c) use any robot, spider, site search or retrieval service, or any other manual or automatic device or process to retrieve, index, data-mine, or in any way reproduce or circumvent the navigational structure or presentation of the Site or Service; or (d) harvest, collect or mine information about users of the Site or Services."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "7. Privacy."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We will use personal information that we collect or obtain in connection with the Site in accordance with our privacy policy which is available here: Privacy Policy ."
        }
      ]
    },
    {
    paragraph: [
      {
        tagType: "h3",
        class: "terms-title",
        text: "8. Warranty Disclaimers."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "No representations or warranties express or implied, are given regarding the legal or other consequences resulting from the use of our Site or Services. The information contained in this is provided for general information only."
      },
      {
        tagType: "p",
        class: "terms-bold-description",
        text: "Your use of the Site or Services is at your sole discretion. The Site and Services are provided on an “AS-IS” and “AS AVAILABLE” basis without warranties of any kind from the Company. THE COMPANY EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY, RELATING TO THE SITE OR SERVICES, INCLUDING WITHOUT LIMITATION THE WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. THE COMPANY DISCLAIMS ANY WARRANTIES, EXPRESS OR IMPLIED, (I) REGARDING THE SECURITY, ACCURACY, RELIABILITY, TIMELINESS AND PERFORMANCE OF THE SITE OR SERVICES; OR (II) THAT THE SITE WILL BE ERROR-FREE OR THAT ANY ERRORS WILL BE CORRECTED; OR (III) REGARDING THE PERFORMANCE OF OR ACCURACY, QUALITY, CURRENCY, COMPLETENESS OR USEFULNESS OF ANY INFORMATION OR SERVICES PROVIDED BY THE SITE. THE COMPANY MAKES NO COMMITMENT TO UPDATE THE INFORMATION CONTAINED IN THE SITE."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "If you choose to rely on information from the Site, you do so solely at your own risk. Some states or jurisdictions do not allow the exclusion of certain warranties. Accordingly, some of the above exclusions may not apply to you."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "ANY KIND, EXPRESS OR IMPLIED, AS TO THE SECURITY OF ANY INFORMATION YOU MAY PROVIDE OR ACTIVITIES YOU ENGAGE IN DURING THE COURSE OF YOUR USE OF THE SITE. PASTIME LIVE DOES NOT GUARANTEE THAT THE SITE WILL BE FREE OF TECHNICAL ERRORS, SECURITY BREACHES, OR VIRUS ATTACKS. THE SITE MAY OCCASIONALLY BE UNAVAILABLE FOR ROUTINE MAINTENANCE, UPGRADING, OR OTHER REASONS. YOU AGREE THAT PASTIME LIVE WILL NOT BE HELD RESPONSIBLE FOR ANY CONSEQUENCES TO YOU OR ANY THIRD PARTY THAT MAY RESULT FROM TECHNICAL PROBLEMS OF THE INTERNET, SLOW CONNECTIONS, TRAFFIC CONGESTION OR OVERLOAD OF OUR OR OTHER SERVERS. WE DO NOT WARRANT, ENDORSE OR GUARANTEE ANY CONTENT, PRODUCT, OR SERVICE THAT IS FEATURED OR ADVERTISED ON THE SITE BY A THIRD PARTY."
      }
    ]
  },
  {
    paragraph: [
      {
        tagType: "h3",
        class: "terms-title",
        text: "9. Limitation of Liability."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "IN NO EVENT SHALL THE COMPANY OR ANY OF ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU FOR ANY DAMAGES WHATSOEVER, INCLUDING WITHOUT LIMITATION, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, AND/OR CONSEQUENTIAL DAMAGES, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE SITE OR ANY CONTENT INCLUDED ON THE SITE (INCLUDING ADVERTISEMENTS), INCLUDING BUT NOT LIMITED TO THE QUALITY, ACCURACY, OR UTILITY OF THE INFORMATION PROVIDED AS PART OF OR THROUGH THE SITE, WHETHER THE DAMAGES ARE FORESEEABLE AND WHETHER OR NOT THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE JURISDICTION."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "In addition to the foregoing, the Company assumes no responsibility for any error, omission, interruption, deletion, defect, delay in operation or transmission, communications line failure, theft or destruction or unauthorized access to, or alteration of, any content. The Company is not responsible for any problems or technical malfunction of any telephone or cellular phone network or lines, computer online systems, servers or providers, computer equipment, software, failure of any email due to technical problems or traffic congestion on the Internet or on the Site, including any injury or damage to users or to any person’s mobile device or computer related to or resulting from participation or downloading materials in connection with the Site."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "UNDER NO CIRCUMSTANCES SHALL THE COMPANY BE RESPONSIBLE FOR ANY LOSS OR DAMAGE, INCLUDING PERSONAL INJURY OR DEATH, RESULTING FROM USE OF THE SITE OR FROM ANY CONTENT POSTED ON OR THROUGH THE SITE."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "IN NO EVENT SHALL THE AGGREGATE LIABILITY OF PASTIME LIVE FOR ANY AND ALL DAMAGES ARISING UNDER THESE TERMS OR OUT OF YOUR USE OF, OR INABILITY TO USE, THE SITE EXCEED THE TOTAL AMOUNT OF US$100."
      }
    ]
  },
      {
    paragraph: [
      {
        tagType: "h3",
        class: "terms-title",
        text: "10. Indemnity."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "You agree to defend, indemnify and hold harmless Pastime LIVE and our affiliates, and our respective officers, directors, employees and agents, from and against any and all claims, damages, obligations, losses, liabilities, costs and expenses (including but not limited to attorney's fees) arising from: (i) your use of, or inability to use, the Site; or (ii) your violation of these Terms."
      }
    ]
  },
      {
    paragraph: [
      {
        tagType: "h3",
        class: "terms-title",
        text: "11. Term and Termination."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "These Terms are effective until terminated by Pastime LIVE. Pastime LIVE , in its sole discretion, has the right to terminate these Terms and/or your access to the Site, or any part thereof, immediately at any time and with or without cause (including, without any limitation, for a breach of these Terms). Pastime LIVE shall not be liable to you or any third party for termination of the Site, or any part thereof. If you object to any term or condition of these Terms, or any subsequent modifications thereto, or become dissatisfied with the Site in any way, your only recourse is to immediately discontinue use of the Site. Upon termination of these Terms, you shall cease all use of the Site. This Section 11 and Sections 4 (the Service), 6 (Intellectual Property Rights), 7 (Privacy), 8 (Warranty Disclaimers), 9 (Limitation of Liability), 10 (Indemnity), and 13 (General) shall survive termination of these Terms."
      }
    ]
  },
      {
    paragraph: [
      {
        tagType: "h3",
        class: "terms-title",
        text: "12. Assignment."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "These Terms, and any rights and licenses granted hereunder, may not be transferred or assigned by you but may be assigned by Pastime LIVE without restriction or notification to you."
      }
    ]
  },
  {
    paragraph: [
      {
        tagType: "h3",
        class: "terms-title",
        text: "13. General."
      },
      {
        tagType: "p",
        class: "terms-description",
        text: "Pastime LIVE reserves the right to discontinue or modify any aspect of the Site at any time. These Terms and the relationship between you and Pastime LIVE shall be governed by and construed in accordance with the laws of the State of Israel, without regard to its principles of conflict of laws. You agree to submit to the personal and exclusive jurisdiction of the courts located in Tel Aviv-Jaffa and waive any jurisdictional, venue, or inconvenient forum objections to such courts, provided that Pastime LIVE may seek injunctive relief in any court of competent jurisdiction. These Terms shall constitute the entire agreement between you and Pastime LIVE concerning the Site. If any provision of these Terms is deemed invalid by a court of competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining provisions of these Terms, which shall remain in full force and effect. No waiver of any term of these Terms shall be deemed a further or continuing waiver of such term or any other term, and a party's failure to assert any right or provision under these Terms shall not constitute a waiver of such right or provision. YOU AGREE THAT ANY CAUSE OF ACTION THAT YOU MAY HAVE ARISING OUT OF OR RELATED TO THE SITE MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION OCCURS. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED."
      }
    ]
  }
]};